import React, { useState } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export default function ThinkyIOTDeviceManagement({ onBack }) {
  const [devices, setDevices] = useState([
    { id: 1, name: 'Device A', status: 'Online', lastActive: '2 mins ago' },
    { id: 2, name: 'Device B', status: 'Offline', lastActive: '15 mins ago' },
    { id: 3, name: 'Device C', status: 'Online', lastActive: '30 secs ago' },
    { id: 4, name: 'Device D', status: 'Error', lastActive: '5 mins ago' },
  ]);

  const toggleStatus = (id) => {
    setDevices(devices.map(d => d.id === id ? {...d, status: d.status === 'Online' ? 'Offline' : 'Online'} : d));
  };

  const generateDummyChartData = () => {
    const labels = Array.from({length: 10}, (_, i) => `T-${10-i}`);
    const data = labels.map(() => Math.floor(Math.random() * 100));
    return { labels, datasets: [{ label: 'Telemetry', data, borderColor: '#3b82f6', backgroundColor: 'rgba(59, 130, 246, 0.2)' }] };
  };

  return (
    <div className="min-h-screen bg-black text-white px-4 py-8">
      <button onClick={onBack} className="mb-6 px-4 py-2 bg-blue-600 rounded hover:bg-blue-500 w-24">&larr; Back</button>
      <h1 className="text-lg lg:text-xl font-bold mb-6">Device & Asset Management</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        {devices.map(device => (
          <div key={device.id} className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm">
            <h3 className="text-lg font-semibold mb-2">{device.name}</h3>
            <p>Status: <span className={`font-semibold ${device.status === 'Online' ? 'text-green-400' : device.status === 'Offline' ? 'text-gray-400' : 'text-red-500'}`}>{device.status}</span></p>
            <p>Last Active: {device.lastActive}</p>
            <button onClick={() => toggleStatus(device.id)} className="mt-3 px-3 py-1 bg-blue-600 rounded hover:bg-blue-500">Toggle Status</button>

            <div className="mt-4">
              <Line data={generateDummyChartData()} options={{ responsive: true, plugins: { legend: { labels: { color: 'white' } }, title: { display: true, text: 'Recent Telemetry', color: 'white' } }, scales: { x: { ticks: { color: 'white' }, grid: { color: '#374151' } }, y: { ticks: { color: 'white' }, grid: { color: '#374151' } } } }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
